import { defineComponent as _defineComponent } from 'vue'
import type { HomeModules } from '@/features/onboarded-home/types';
import type { AssertByTypename } from '@/helpers/graphql-model-helper';
import type {
	GetHomeModulesQuery,
	GetHomeModulesQueryVariables,
} from '@/features/onboarded-home/graphql/queries/GetHomeModules.query';

import { ModalHelper } from '@/helpers/modal-helper';

import { VisibleFlyoutType } from '@/stores/user.store';
import { GetHomeModulesDocument } from '@/features/onboarded-home/graphql/queries/GetHomeModules.query';

import SpinnerDots from '@/features/ui/components/SpinnerDots.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import CalendarIcon from '@/components/CalendarIcon.vue';
import ProvidersButton from '@/components/filter-bar/ProvidersButton.vue';
import ModulesLoader from '@/features/onboarded-home/components/ModulesLoader.vue';
import EndCard from '@/features/onboarded-home/components/EndCard.vue';

import { PackagesSelectionModal } from '@/lazy-load-components';
import { ProviderFilterPlace } from '@/enums/provider-filter-place';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { useQuery } from '@/helpers/composables/useApollo';
import { useLanguageStore, useUserStore, useRoutingStore } from '@/helpers/composables/useStores';
import { useRoute } from 'vue-router/composables';

import { useMediaQuery } from '@vueuse/core';
import { computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardedHome',
  setup(__props) {

const { language, country } = useLanguageStore();
const { activeDomain } = useRoutingStore();
const { settings, isFlyoutVisible } = useUserStore();

const route = useRoute();

const enabled = computed(() => route.name === 'app.home');
const { result, loading } = useQuery<GetHomeModulesQuery, GetHomeModulesQueryVariables>(
	GetHomeModulesDocument,
	() => ({
		fullPath: route.fullPath,
		site: activeDomain.value,
		country: country.value,
		language: language.value,
		locale: `${language.value.toLowerCase()}-${country.value.toUpperCase()}`,
		watchNowFilter: {
			packages: settings.value.providers,
			withFallback: true,
		},
		testingMode: route.query['modules_testing'] === 'true',
	}),
	{
		fetchPolicy: 'cache-first',
		prefetch: false,
		errorPolicy: 'all',
		enabled,
	}
);

const homeModules = computed(() => {
	const node = result.value?.urlV2.node;
	const modules = (node as AssertByTypename<typeof node, 'HomePage'>)?.modules ?? [];

	return modules.filter(module => module != null) as HomeModules;
});

const isLoading = computed(() => loading.value || homeModules.value.length === 0);

const isMobileWeb = useMediaQuery('(max-width: 480px)');

function openProvidersSelection() {
	ModalHelper.openModal(
		PackagesSelectionModal,
		{ providerPlace: ProviderFilterPlace.SETTINGS },
		{ cssClass: 'packages-selection-modal' },
		ProviderFilterPlace.SETTINGS,
		true
	);
}

/* TRACKING */
onMounted(() => {
	window.addEventListener('beforeunload', () => {
		TrackingHelper.trackEvent('discovery', {
			action: 'session_refreshed',
			label: 'page_refresh',
		});
	});

	TrackingHelper.trackEvent('module', {
		action: 'started_loading',
		nonInteraction: true,
	});
});

return { __sfc: true,language, country, activeDomain, settings, isFlyoutVisible, route, enabled, result, loading, homeModules, isLoading, isMobileWeb, openProvidersSelection, VisibleFlyoutType, SpinnerDots, FadeTransition, CalendarIcon, ProvidersButton, ModulesLoader, EndCard }
}

})